import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const ReducarbVariant = () => {
  const { blendName } = useParams();
  const [activeBlend, setActiveBlend] = useState("Macronutrient");

  const blends = [
    { name: "Macronutrient", contentId: "macronutrient" },
    { name: "Micronutrients", contentId: "micronutrients" }
  ];

  useEffect(() => {
    // Set the active blend based on the blendName from the URL or fallback to default
    const blend = blends.find(
      (b) => b.name.toLowerCase() === blendName?.toLowerCase()
    );
    setActiveBlend(blend ? blend.name : "Macronutrient");
  }, [blendName]);

  return (
    <section className="fresh-vegetable-section section-lg-space">
      <div className="container-fluid-lg">
        <div className="row">
          {/* Left Column */}
          <div className="col-xl-4 font-smd mb-3">
            <div className="width_75">
              {blends.map((blend, index) => (
                <div
                  key={index}
                  className={`mb-3 font-smd boder-radius-twenty ${
                    activeBlend === blend.name
                      ? "active_background_white fw-semibold"
                      : "grey_non_active fw-semibold"
                  }`}
                  onClick={() => setActiveBlend(blend.name)}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {blend.name} Blend
                  {activeBlend === blend.name && (
                    <hr
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        bottom: 0,
                        opacity: 1,
                        height: "100%",
                        borderLeft: "5px solid var(--theme-color)",
                        margin: 0,
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="col-xl-8">
            {/* Macronutrient Content */}
            {activeBlend === "Macronutrient" && (
              <div id="macronutrient" className="content-section">
                <div
                  className="custom-image-container text-white reducarb-blends-images background_blue_section_Know_your fresh-image-2 d-flex justify-content-start align-items-center "
                  style={{
                    backgroundImage:
                      "url('../assets/images/ReducarbBlends/reducarb-blends_banner.jpg')",
                  }}
                >
                  <div>
                    <h1 className="font-lg mb-3">Macronutrient <br></br>Blends</h1>
                  </div>
                </div>

                <div className="mt-3">
                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      1{")"} Carbohydrate Blend:
                    </div>
                    <p className="font-xsm justify_content">
                    Although carbohydrate requirements are similar in both genders, American Health Association recommends lesser daily added 
                    sugars in females than males (25 vs 36 gm per day) Further, 
                    various surveys shows that females cross their daily carbohydrate limits more often than males.
                    
                    Hence, Reducarb Her has less carbohydrates and added sugars than Reducarb Him.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      2{")"} Protein:
                    </div>
                    <p className="font-xsm justify_content">
                    Males have higher protein requirement than females due to higher lean body mass,
                    Hence, Reducarb Him version has higher proteins compared to Her version.

                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      3) Fat Blend:
                    </div>
                    <p className="font-xsm justify_content">
                    Men and women differ in the patterns of fat deposition and fat utilisation by the body. 
                    Women generally have a larger proportion of body fat mass as compared to men. Oestrogen plays a role in 
                    distribution of fat deposition in women. It appears to be protective against abdominal fat deposition in 
                    women in reproductive age group but, loss of oestrogens after menopause makes women more vulnerable to 
                    abdominal obesity. Many women notice an increase in belly fat as they get older even if they don't gain weight. 
                    This is likely due to lower levels of estrogen. Higher fat intake is associated with abdominal obesity in females.

                    <br/>
                    Hence, Reducarb Her has less fat content and contribution to total energy than Reducarb Him 
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      4) Fiber Content:
                    </div>
                    <p className="font-xsm justify_content">
                    Indian diet is rich in unrefined grains and vegetable products and generally provide the required daily fiber intake. 
                    However, with changing dietary pattern, the fiber intake varies between 15 and 41 g fiber/day and in women the intake 
                    is much lower than 15-30 g per day. 
                    Hence, females need higher support to meet their daily requirement.
                    Hence, Reducarb Her has more fiber content than Reducarb Him.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Micronutrients Content */}
            {activeBlend === "Micronutrients" && (
              <div id="micronutrients" className="content-section">
                <div
                  className="custom-image-container text-white reducarb-blends-images background_blue_section_Know_your fresh-image-2 d-flex justify-content-start align-items-center "
                  style={{
                    backgroundImage:
                      "url('../assets/images/ReducarbBlends/reducarb-blends_banner.jpg')",
                  }}
                >
                  <div>
                    <h1 className="font-lg mb-3">Micronutrients <br/>Blends</h1>
                  </div>
                </div>

                <div className="mt-3">
                  <div>
                    <p className="font-xsm justify_content">
                    Indian Medical Research council (ICMR) has recently defined Recommended Daily Allowances for various vitamins and 
                    nutrients. Males and females differ in their requirement of key micronutrients like Iron, Calcium Folate, 
                    Vitamin C, A etc. Taking into consideration these differences, Reducarb Her has more iron (50% of RDA) 
                    while Reducarb Him has more Vitamin B1, B2, Vit C, Folate, Vit A and Zinc. <br/>
                    Gender specific needs are considered in providing 50% RDA of key vitamins like Vit B12, folic acid, 
                    Vit C, Vit A, Vit D, iron and 30% RDA of calcium. 
                    </p>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </section>
  );
};

export default ReducarbVariant;
